import React from 'react';
import FormStep from '../components/FormStep';
import { FormSettingsControls, isFormStep } from '../types/IFormSettings';
import { getFormChild } from './getFormChild';

export function getFormChildren(controls: FormSettingsControls[], formName: string) {
    if (isFormStep(controls[0])) {
        return [<FormStep key="form-section" formName={formName} controls={controls} />];
    }

    return controls.map((control, i) => getFormChild(control, formName, i));
}
